export { default as DocumentUploadOutlineIcon } from './DocumentUploadOutlineIcon';
